import styles from './ListNavigationDrawer.module.css';
import { forwardRef, useImperativeHandle } from 'react';
import { ListDrawerProvider, useListDrawerContext } from './ListDrawerProvider';
import ListNavigation from './ListNavigation';
import DrawerContent from './DrawerContent';
import Spinner from 'ui/Spiner';
import useLoadingEffect from '../../hooks/useLoadingEffect';
import { MODE_NAVIGATION } from 'consts/navigationDrawer.consts';
import TreeNavigation from './TreeNavigation';
import SplitScreen from 'widgets/SpitScreen';

const ListNavigationDrawer = forwardRef(({ children, ...rest }, ref) => {
  return (
    <ListDrawerProvider {...rest}>
      <ListDrawerComponent ref={ref} mode={rest.mode}>
        {children}
      </ListDrawerComponent>
    </ListDrawerProvider>
  );
});

const ListDrawerComponent = forwardRef(({ children = null, mode = MODE_NAVIGATION.list }, ref) => {
  const {
    setSelected,
    isLoading,
    allowResize,
    initialFirstPaneSize,
    minSizeFirstPane,
    maxSizeFirstPane,
  } = useListDrawerContext();
  const { loadingVisible } = useLoadingEffect(isLoading);

  useImperativeHandle(ref, () => ({
    resetSelected: () => setSelected(null),
  }));

  return (
    <>
      {loadingVisible && <Spinner overlay />}

      <SplitScreen
        allowResize={allowResize}
        initialFirstPaneSize={initialFirstPaneSize}
        minSizeFirstPane={minSizeFirstPane}
        maxSizeFirstPane={maxSizeFirstPane}
      >
        {mode === MODE_NAVIGATION.list ? <ListNavigation /> : <TreeNavigation />}
        <DrawerContent>{children}</DrawerContent>
      </SplitScreen>
    </>
  );
});

ListDrawerComponent.displayName = 'ListDrawerComponent';
ListNavigationDrawer.displayName = 'ListNavigationDrawer';

export default ListNavigationDrawer;
